// extracted by mini-css-extract-plugin
export default {"buttonsList":"VehicleButtonCustomization_buttonsList__HnlUY","addButtonWrapper":"VehicleButtonCustomization_addButtonWrapper__MRI4y"};